import type { LobbyPlayer } from "@rosette/ts/src/business/lobby/LobbyPlayer.js";
import type { PlayerType } from "@rosette/ts/src/royalur/model/PlayerType.js";
import { useOptionalUser } from "@/components/env/EnvContext.js";
import { useGamePreferences } from "@/app/(api)/api/getGamePreferences/useGamePreferences.js";
import { PlayerDescPopupButton } from "@/components/game/playerstate/PlayerDesc.js";
import { defaultGamePreferences } from "@rosette/ts/src/business/api/api_schema.js";
import { cn } from "@rosette/ts/src/util/cn.js";


export interface PlayerNameProps {
    className?: string;
    player: LobbyPlayer;
    yourPlayer: PlayerType | null;
    small?: boolean;
}


export function PlayerName({ className, player, yourPlayer, small }: PlayerNameProps) {
    const playerUser = player.getUserOrNull();
    const activeUser = useOptionalUser();

    const useActiveUserPref = (
        yourPlayer === player.getPlayerType()
        && playerUser && activeUser
        && playerUser.publicID === activeUser.publicID
    );
    const { preferences: activeUserPref } = useGamePreferences(useActiveUserPref ? activeUser : null);

    const pref = (useActiveUserPref ? activeUserPref : player.getPreferences());
    return (
        <div className={className}>
            <PlayerDescPopupButton
                buttonClassName="m-0 hover:no-underline"
                buttonPlayerNameClassName={cn(
                    "m-0 font-bold text-body",
                    small ? "text-xl" : "text-2xl",
                )}
                player={player}
                yourPlayer={yourPlayer}
                positionLeft={true}
                playerConnected={true}
                preferences={pref ?? defaultGamePreferences}
                outOfGame={true} />
        </div>
    );
}
